import { useCallback } from 'react';

export default function useOnFormChange(onChange) {
  return useCallback((value, name) => onChange({ [name]: value }), [onChange]);
}
